<div class="mt-2 flex h-full min-h-0 flex-col overflow-hidden [&_.cdk-drag-placeholder]:opacity-30">

  @if (cards.length > 3 && !quickCreateTemplate) {
    <cdk-virtual-scroll-viewport
      class="crm-scroll h-full min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain [-webkit-overflow-scrolling:touch] [contain:strict] [scroll-padding-bottom:16px] [&_.cdk-virtual-scroll-content-wrapper]:w-full [&_.cdk-virtual-scroll-content-wrapper]:max-w-full"
      cdkDropList
      [id]="columnId"
      [cdkDropListData]="cards"
      [cdkDropListConnectedTo]="connectedTo"
      [itemSize]="itemSize"
      [minBufferPx]="300"
      [maxBufferPx]="600"
      (cdkDropListDropped)="onDrop($event)"
      (scrolledIndexChange)="onScrolledIndexChange($event)"
    >
      <div
        *cdkVirtualFor="let card of cards; trackBy: trackById; templateCacheSize: 0"
        class="mb-2"
        cdkDrag
        [cdkDragData]="card"
        [cdkDragStartDelay]="dragStartDelay"
        [cdkDragDisabled]="selectionMode"
        (cdkDragStarted)="cardDragStart.emit()"
        (cdkDragEnded)="cardDragEnd.emit()"
      >
        <app-board-v3-card-item
          [card]="card"
          [viewFields]="viewFields"
          [allFields]="allFields"
          [canMove]="canMoveCards"
          [selectionMode]="selectionMode"
          [selected]="isSelected(card)"
          (selectionToggle)="cardSelectionToggle.emit($event)"
          (cardClick)="cardClick.emit($event)"
          (cardDelete)="cardDelete.emit($event)"
          (cardMoveClick)="cardMoveClick.emit($event)"
          (chatClick)="chatClick.emit($event)"
        />
      </div>
    </cdk-virtual-scroll-viewport>
  } @else {
    <div
      class="crm-scroll h-full min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain [-webkit-overflow-scrolling:touch] [scroll-padding-bottom:16px]"
      cdkDropList
      [id]="columnId"
      [cdkDropListData]="cards"
      [cdkDropListConnectedTo]="connectedTo"
      (cdkDropListDropped)="onDrop($event)"
      (scroll)="onScroll($event)"
    >
      @if (quickCreateTemplate) {
        <ng-container [ngTemplateOutlet]="quickCreateTemplate" />
      }
      @for (card of cards; track trackById($index, card)) {
        <div
          class="mb-2"
          cdkDrag
          [cdkDragData]="card"
          [cdkDragStartDelay]="dragStartDelay"
          [cdkDragDisabled]="selectionMode"
          (cdkDragStarted)="cardDragStart.emit()"
          (cdkDragEnded)="cardDragEnd.emit()"
        >
          <app-board-v3-card-item
            [card]="card"
            [viewFields]="viewFields"
            [allFields]="allFields"
            [canMove]="canMoveCards"
            [selectionMode]="selectionMode"
            [selected]="isSelected(card)"
            (selectionToggle)="cardSelectionToggle.emit($event)"
            (cardClick)="cardClick.emit($event)"
            (cardDelete)="cardDelete.emit($event)"
            (cardMoveClick)="cardMoveClick.emit($event)"
            (chatClick)="chatClick.emit($event)"
          />
        </div>
      }
    </div>
  }

  @if (isLoading) {
    <div class="flex items-center justify-center py-2">
      <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-500"></div>
    </div>
  }
</div>
